import React, { useEffect, useState } from 'react';
import { getNameClient } from './../../helpers/nameClient';
import { useSelector, useDispatch } from 'react-redux';
import PageTitle from '../../components/Common/MetaTagsHelper/metaTagsHelper';
import { Container, Row } from 'reactstrap';
import Swal from 'sweetalert2';
import { getClients, addClients, updateClients, deleteClients } from '../../store/actions';

import Breadcrumbs from '../../components/Common/Breadcrumb/Breadcrumb';
import { ITable } from '../../components/Common/iComponents/iTable/ITable';
import { IPopUp } from '../../components/Common/iComponents/iPopUp/IpopUp';
import FormClient from './form-client';
import { ISwitch } from '../../components/Common/iComponents/iSwitch/iSwitch';
import { IInput } from '../../components/Common/iComponents/iInput/iInput';
import usePageTitle from '../../common/hooks/usePageTitle';

const ClientList = (props: any) => {
    const dispatch = useDispatch();
    const { clients, CountItems } = useSelector((state: any) => state.clients);
    const [tableViewList] = useState([]);
    const [pagination, setPagination] = useState<{
        sizePerPage: number;
        page: number;
    }>({
        sizePerPage: 50,
        page: 1,
    });
    const [popUpState, setpopUpState] = useState(false);
    const [updateState, setUpdateState] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [listDataState, setListDataState] = useState([]);

    const PageTitleClients = usePageTitle(props.location.pathname);

    const textName = 'Search Name';
    const textEmail = 'Search Email';

    const [queryString, setQueryString] = useState<any>({});

    useEffect(() => {
        setListDataState(clients);
    }, [clients]);

    const initialArrayTable = [
        {
            text: 'Name',
            dataField: 'name',
            formatter: (cellContent: any, clients: any) => <>{clients.name}</>,
            hidden: false,
        },
        {
            text: 'Email',
            dataField: 'email',
            formatter: (cellContent: any, clients: any) => <>{clients.email}</>,
            hidden: false,
        },
        {
            text: 'Company',
            dataField: 'company',
            formatter: (cellContent: any, clients: any) => <>{clients.company}</>,
            hidden: false,
        },
        {
            text: 'Description',
            dataField: 'description',
            formatter: (cellContent: any, clients: any) => <>{clients.description}</>,
            hidden: false,
        },
        {
            text: 'enabled',
            dataField: 'enabled',
            formatter: (cellContent: any, clients: any) => {
                return (
                    <ISwitch
                        checked={clients.enabled}
                        onChangeBooleanHandler={(args) => {
                            const newObject = { ...clients };
                            newObject.enabled = args;
                            dispatch(updateClients({ newObject, data: queryString }));
                        }}
                    />
                );
            },
            hidden: false,
        },
    ];

    useEffect(() => {
        dispatch(getClients({ pagination }));
    }, [dispatch, pagination]);

    const handleCreateClient = (client: any) => {
        setpopUpState(!popUpState);
        dispatch(addClients(client));
        Swal.fire({
            icon: 'success',
            title: 'Added!!!',
            text: 'New items have been added successfully!!!',
        });
    };

    const handleUpdateClient = (client: any) => {
        setpopUpState(!popUpState);
        dispatch(updateClients({ newObject: client, data: queryString }));
        Swal.fire({
            icon: 'success',
            title: 'Updated!!!',
            text: 'New items have been updated successfully!!!',
        });
    };

    const handleDeleteClients = (id: any) => {
        setpopUpState(!popUpState);
        dispatch(deleteClients(id));
        Swal.fire({
            icon: 'success',
            title: 'Deleted!!!',
            text: 'Items have been deleted successfully!!!',
        });
    };

    const handleCancel = (id: any) => {
        setpopUpState(!popUpState);
    };

    const onPopUpState = () => {
        setpopUpState(!popUpState);
    };

    const handleActionOnRowClick = (row: any) => {
        setSelectedRow(row);
    };

    const handleAddAction = () => {
        setUpdateState(false);
        setpopUpState(!popUpState);
        setSelectedRow(null);
    };

    useEffect(() => {
        let userConsultName = false;
        let userConsultEmail = false;

        const queryTextName = queryString[textName] ?? '';
        const queryTextEmail = queryString[textEmail] ?? '';

        if (queryTextEmail.length > 3 || queryTextEmail === '') {
            userConsultName = true;
        }
        if (queryTextName.length > 3 || queryTextName === '') {
            userConsultEmail = true;
        }

        if (userConsultName && userConsultEmail) {
            setListDataState([]);
            dispatch(getClients({ data: queryString, pagination }));
        }
    }, [dispatch, pagination, queryString]);

    const onChangeHandler = (e: any, n: any) => {
        setQueryString({ ...queryString, [n]: e.target.value });
    };

    const handlePaginationChange = (newState: any) => {
        setPagination(newState);
    };
    const AdminFilters = () => {
        return (
            <>
                <div className="col-5">
                    <div className="justify-content-center">
                        <IInput title={textName} type={'text'} value={queryString[textName]} onChangeHandler={onChangeHandler} />
                    </div>
                </div>
                <div className="col-5">
                    <div className="justify-content-center">
                        <IInput title={textEmail} type={'text'} value={queryString[textEmail]} onChangeHandler={onChangeHandler} />
                    </div>
                </div>
            </>
        );
    };

    return (
        <React.Fragment>
            <div id="navbar"></div>
            <div className="pageContent">
                <PageTitle>
                    <title>{PageTitleClients.replace(/-/g, ' ')} | {getNameClient()}</title>
                </PageTitle>
                <Container fluid>
                    <Row>
                        <div className="row justify-content-center me-2">
                            <div className="d-flex justify-content-end pb-3">
                                <button type="button" className="btn bg-primary text-white add-primary-button" onClick={handleAddAction}>
                                    + Add
                                </button>
                            </div>
                            {AdminFilters()}
                        </div>
                    </Row>
                    <Row>
                        <Row>
                            <ITable
                                remote
                                disablePageTitle
                                data={listDataState}
                                CountItems={CountItems}
                                fields={initialArrayTable}
                                tableColumns={initialArrayTable}
                                handlerPaginationState={handlePaginationChange}
                                headerColorT="bg-primary text-white"
                                tableViewList={tableViewList}
                                groupName=""
                                handlePopUpState={onPopUpState}
                                actionOnRowClick={handleActionOnRowClick}
                            />
                        </Row>
                    </Row>
                </Container>
            </div>

            <IPopUp
                stateAdd={popUpState}
                switchStateAdd={setpopUpState}
                stateUpdate={updateState}
                switchStateUpdate={setUpdateState}
                modalTitleAdd={'Clients'}
                modaleTitleUpdate={'Update Clients'}
                icon="users"
                colorHeaderPop={'#101340'}
            >
                <FormClient
                    selectedRow={selectedRow}
                    onCreateClient={handleCreateClient}
                    onUpdateClient={handleUpdateClient}
                    onDeleteClients={handleDeleteClients}
                    onCancel={handleCancel}
                />
            </IPopUp>
        </React.Fragment>
    );
};

export default ClientList;
